import { AnyAction } from 'redux';
import { BenefitEnrollmentStep } from '../../../arc/features/new-hire-enrollment/models/pension-enrollment-models';
import { MyCpgMidYearActions, MyCpgMidYearState } from './models/mycpg-mid-year-models';


const InitialState: MyCpgMidYearState = {
	currentStep: null,
};


export const myCpgMidYearEnrollmentReducer = (state = InitialState, action: AnyAction): MyCpgMidYearState => {


	switch (action.type) {		
		case MyCpgMidYearActions.SET_MYCPG_MID_YEAR_CURRENT_STEP:
			return {
				...state,
				currentStep: action.payload,
			};

		default: return state;
	}
};


export const setCurrentMyCpgMidYearStep = (step: BenefitEnrollmentStep) => {
	return {
		type: MyCpgMidYearActions.SET_MYCPG_MID_YEAR_CURRENT_STEP,
		payload: step,
	};
};
